import React, { Component, PropTypes } from 'react';
import {Link} from 'react-router';
import styles from '../Header.scss';

export default class HeaderLogo extends Component {
  render() {
    return (
      <Link to="/" className={styles.logo}>
        <span className={styles.domainName}>Sigma</span>
        {/* <span className={styles.logoDot}>.</span>
        <span className={styles.domain}>ru</span> */}
      </Link>
    );
  }
}



HeaderLogo.propTypes = {
};



/** WEBPACK FOOTER **
 ** ./src/components/Header/elements/HeaderLogo.jsx
 **/